// extracted by mini-css-extract-plugin
module.exports = {"ModalContent":"📚4-7-0ge47Q"};